import React from 'react';
import { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { appStore, AppStore } from './stores';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

interface IStore {
  appStore: AppStore
};

export const StoreContext = createContext<IStore>({
  appStore
});


root.render(
  <React.StrictMode>
    <BrowserRouter>
      <StoreContext.Provider value={{appStore}}>
        <App />
      </StoreContext.Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
